import { IoRibbonOutline } from "react-icons/io5";

// Shown once someone has brought in 3+ real signups via their referral
// link — same shared-component pattern as VerifiedBadge, a different glyph
// and gold-forward palette so the two badges read as distinct at a glance.
export default function ReferralBadge({ count, size = 15, style }) {
  if (!count || count < 3) return null;
  return (
    <span
      title={`Invited ${count} friends to GatherYou`}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 3,
        marginLeft: 6,
        padding: "2px 8px 2px 6px",
        borderRadius: 20,
        background: "var(--accent-gold)",
        color: "#2E2118",
        fontSize: Math.round(size * 0.72),
        fontWeight: 700,
        verticalAlign: 1,
        ...style
      }}
    >
      <IoRibbonOutline size={size} />
      {count}
    </span>
  );
}
